class BlockModel {
    sno?: number;
    count?: number;
    blockId?: number;
    name?: string;
    districtId?: number;
    districtName?: string;
}
export default BlockModel;